<ion-content class="theme-{{userService.theme}}" [ngClass]="{reduced: meetingPulse, 'side-columns': isSideColumns}">
    <div class="content" [ngClass]="{'bigger-header' : userInfo.client_id !== 197 && ((socialEnabled && !meetingPulse) || leaderboardEnabled)}">
        <ion-header class="transparent">
            <app-header class="dark-mode"
                        [middleIcon]="userService.companyLogo !== 'assets/icon/journey-logo.svg'"
                        [middleIconSize]="userService.companyLogoSize"
                        [backIconWork]="false" [@enter]>
            </app-header>
        </ion-header>
        <div class="bg bg-{{userService.companyHeader}}" [ngClass]="{'mobile-bg': platform === 'mobile'}" [@enter]>
        </div>
        <div class="box box-{{userService.companyHeader}}" [@enter] *ngIf="userInfo !== null">
            <div class="title">
                {{'__HOME_HI__' | translate}} {{userInfo.first_name}}
                <div *ngIf="userType !== 'coach'" class="desktop-only welcome-text">{{ userInfo.client_id === 196 ? 'Welcome to Rain Coach' : ('__HOME_WELCOME_TO_MY721__' | translate)}}</div>
                <div *ngIf="userType === 'coach'" class="desktop-only welcome-text">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
            </div>
            <div *ngIf="userType !== 'coach'" class="mobile-only">{{'__HOME_WELCOME_TO_MY721__' | translate}}</div>
            <div *ngIf="userType === 'coach'" class="mobile-only">{{'__HOME_COACH_WELCOME_TO_MY721__' | translate}}</div>
            <div *ngIf="userType !== 'coach'" class="text">{{'__HOME_WELCOME_INTRO_TEXT__' | translate}}</div>
            <div *ngIf="userType === 'coach'" class="text">{{'__HOME_COACH_WELCOME_INTRO_TEXT__' | translate}}</div>
            <div class="copyright-wrap" *ngIf="userInfo.client_id !== 197 && ((socialEnabled && !meetingPulse) || leaderboardEnabled)">
                <div class="header-buttons-wrap">
                    <div *ngIf="socialEnabled && !meetingPulse" (click)="goToSocial()" class="header-button-wrap">
                        <span class="header-btn-text">{{ "__HOME_MULTI_GENIUS_BAR__" | translate }}</span>
                        <button class="icon social-stream"></button>
                    </div>
                    <div *ngIf="leaderboardEnabled" (click)="goToLeaderboard()" class="header-button-wrap margin-left">
                        <span class="header-btn-text">{{ "__HOME_MULTI_GLOBAL_LEADERBOARD__" | translate }}</span>
                        <button class="icon leaderboard"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="box" *ngIf="userInfo === null"></div>

        <div class="shadow-container" *ngIf="userInfo === null">
            <app-skeleton-journey></app-skeleton-journey>
            <app-skeleton-journey></app-skeleton-journey>
            <app-skeleton-journey></app-skeleton-journey>
        </div>

        <div class="shadow-container" *ngIf="userInfo !== null && !!userInfo.dashboard && userInfo.dashboard.sections.length > 0">
            <div class="inner-container" [ngClass]="{'inner-container-manager': authService.getUserType() === 'manager'}">
                <ng-container *ngFor="let section of this.userInfo.dashboard.sections; let i = index;">
                    <button (click)="buttonClicked(section)"
                            class="shadow-element color-{{section.icon}} custom-section-{{section.uid}}"
                            [ngStyle]="{'background-color' : section.background_color}"
                            *ngIf="(section.template !== null && section.template.template.is_visible) || section.sections.length > 0"
                            [ngClass]="{passed: isCertified, disabled: section.sections.length == 0 && (!section.template || !section.template.stages.active.length || !section.template.template.is_active)}">
                        <div class="left">
                            <app-inline-icon-svg [section]="section"></app-inline-icon-svg>
                            <div class="description">
                                <div class="big" [ngStyle]="{'color': section.text_primary_color}" [innerHTML]="section.title"></div>
                                <div class="small"
                                     [ngStyle]="{'color': section.text_secondary_color}"
                                     *ngIf="!!section.subtitle" [innerHTML]="section.subtitle"></div>
                            </div>
                            <img *ngIf="false && i < 2" src="assets/icon/sign.svg" style="padding: 0 1rem">
                            <img *ngIf="false && i >= 2" src="assets/icon/sign-placeholder.svg" style="padding: 0 1rem">
                        </div>
                        <ng-container *ngIf="section.sections.length > 0">
                            <svg *ngIf="isOpened && toggleSectionId === section.id" class="arrow-horizontal" xmlns="http://www.w3.org/2000/svg" width="45.571" height="24.081" viewBox="0 0 45.571 24.081">
                                <g transform="translate(45.571) rotate(90)">
                                    <path d="M199.121,252.775l20.58-20.58a1.29,1.29,0,1,0-1.824-1.824l-21.5,21.5a1.285,1.285,0,0,0,0,1.824l21.5,21.488a1.3,1.3,0,0,0,.907.382,1.259,1.259,0,0,0,.907-.382,1.285,1.285,0,0,0,0-1.824Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_primary_color"/>
                                </g>
                            </svg>
                            <svg *ngIf="!(isOpened && toggleSectionId === section.id)" class="arrow-horizontal" xmlns="http://www.w3.org/2000/svg" width="45.571" height="24.081" viewBox="0 0 45.571 24.081">
                                <g transform="translate(0 24.081) rotate(-90)">
                                    <path d="M199.121,252.775l20.58-20.58a1.29,1.29,0,1,0-1.824-1.824l-21.5,21.5a1.285,1.285,0,0,0,0,1.824l21.5,21.488a1.3,1.3,0,0,0,.907.382,1.259,1.259,0,0,0,.907-.382,1.285,1.285,0,0,0,0-1.824Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_primary_color"/>
                                </g>
                            </svg>

                        </ng-container>
                        <svg *ngIf="section.sections.length === 0" class="arrow" xmlns="http://www.w3.org/2000/svg" width="32.007" height="60.571" viewBox="0 0 32.007 60.571">
                            <g transform="translate(228.008 290.562) rotate(180)">
                                <g transform="translate(196.001 229.991)">
                                    <path d="M200.148,260.274,227.5,232.92a1.714,1.714,0,0,0-2.424-2.425l-28.574,28.574a1.708,1.708,0,0,0,0,2.424l28.574,28.561a1.722,1.722,0,0,0,1.205.508,1.673,1.673,0,0,0,1.206-.508,1.708,1.708,0,0,0,0-2.424Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+section.icon_secondary_color"/>
                                </g>
                            </g>
                        </svg>
                    </button>
                    <ng-container *ngIf="section.sections.length > 0 && isOpened && toggleSectionId === section.id">
                        <ng-container *ngFor="let subSection of this.section.sections">
                            <button (click)="buttonClicked(subSection)"
                                    class="shadow-element sub-section color-{{subSection.icon}} custom-section-{{subSection.uid}}"
                                    [ngStyle]="{'background-color' : subSection.background_color}"
                                    *ngIf="subSection.template !== null && subSection.template.template.is_visible"
                                    [ngClass]="{disabled: !subSection.template || !subSection.template.stages.active.length || !subSection.template.template.is_active}">
                                <div class="left">
                                    <app-inline-icon-svg [section]="subSection"></app-inline-icon-svg>

                                    <div class="description">
                                        <div class="big" [ngStyle]="{'color': subSection.text_primary_color}" [innerHTML]="subSection.title"></div>
                                        <div class="small"
                                             [ngStyle]="{'color': subSection.text_secondary_color}"
                                             *ngIf="!!subSection.subtitle" [innerHTML]="subSection.subtitle"></div>
                                        <div class="small rating"
                                             [ngStyle]="{'color': subSection.text_secondary_color}"
                                             *ngIf="!!subSection.aicoach"><div><strong>{{subSection.aicoach.status}}</strong></div><div>{{ "__HOME_MULTI_BEST_TRY__" | translate }} - <strong>{{subSection.aicoach.score}}</strong></div><div>{{ "__HOME_MULTI_RANK__" | translate }} <strong>{{subSection.aicoach.rank > 0 ? '#' : ''}}{{subSection.aicoach.rank}}</strong></div> </div>
                                    </div>
                                </div>
                                <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="32.007" height="60.571" viewBox="0 0 32.007 60.571">
                                    <g transform="translate(228.008 290.562) rotate(180)">
                                        <g transform="translate(196.001 229.991)">
                                            <path d="M200.148,260.274,227.5,232.92a1.714,1.714,0,0,0-2.424-2.425l-28.574,28.574a1.708,1.708,0,0,0,0,2.424l28.574,28.561a1.722,1.722,0,0,0,1.205.508,1.673,1.673,0,0,0,1.206-.508,1.708,1.708,0,0,0,0-2.424Zm0,0" transform="translate(-196.001 -229.991)" [style]="'fill: '+subSection.icon_secondary_color"/>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </ng-container>
                    </ng-container>
                </ng-container>

                <div class="side-container meeting-pulse" *ngIf="meetingPulse">
                    <div *ngIf="false" class="header" style="background-color: #209F9C; justify-content: flex-start; height: 4rem; margin-top: .5rem;">{{ "__HOME_MULTI_WHATS_HAPPENING_NOW__" | translate }}</div>
                    <div class="body no-padding">
                        <iframe  [src]="this.socialUrl | safeUrl" style="border:none; width: 100%; height: 500px;" allow=“encrypted-media” credentialless>
                        </iframe>
                    </div>
                </div>

                <div class="side-container meeting-pulse" *ngIf="socialBlock && socialUrl">
                    <div class="header">{{'L1 & L2 Discussion' | translate}}</div>
                    <div class="body no-padding">
                        <iframe [src]="socialUrl | safeUrl" style="border:none; width: 100%; height: 500px;" allow=“encrypted-media” credentialless>
                        </iframe>
                    </div>
                </div>

                <!-- Side columns reorganized into two containers -->
                <div class="side-wrapper-left">
                    <!-- One to One Coaching -->
                    <div class="side-container coaching-journey"
                         *ngIf="userInfo.client_id == 167 && userService.userInfo.is_coaching"
                         (click)="goOne2OneCoaching()">
                        <div class="header">{{'One to One Coaching' | translate}}</div>
                        <div class="body">
                            <img src="assets/img/inspire/one2one-coaching.svg" alt="">
                            <div>{{ "__HOME_MULTI_CLICK_TO_BOOK_YOUR_QUALIFIED_COACH__" | translate }}</div>
                        </div>
                    </div>

                    <!-- My Journal -->
                    <div class="side-container my-journal"
                         *ngIf="userInfo.client_id == 95 && !!pmiJournalTemplate"
                         (click)="goPmiJournalTemplate()">
                        <div class="header">{{'My Journal' | translate}}</div>
                        <div class="body">
                            <img src="assets/img/inspire/pmi-journal.svg" alt="">
                            <div>{{ "__HOME_MULTI_VIEW_MORE_INFO_ABOUT_YOUR_JOURNAL__" | translate }}</div>
                        </div>
                    </div>

                    <!-- My Development -->
                    <div class="side-container my-journal"
                         *ngIf="isCallDashboardEnabled"
                         (click)="goCallsDashboard()">
                        <div class="header primary-bg-color">{{'My Development' | translate}}</div>
                        <div class="body">
                            <app-inline-svg [cssClass]="'img'" [file]="'assets/img/checklist.svg'" ></app-inline-svg>
                            <div>{{ "__HOME_MULTI_CLICK_TO_VIEW_MORE_INFO__" | translate }}</div>
                        </div>
                    </div>

                  <div class="side-container search-resources" *ngIf="searchEnabled">
                    <div class="header">{{'__HOME_MULTI_SEARCH_RESOURCES__' | translate}}</div>
                    <div class="body">
                      <app-search-widget></app-search-widget>
                    </div>
                  </div>

                    <!-- Personal Insights -->
                    <div class="side-container personal-insights"
                         *ngIf="userInfo.client_id == 70"
                         (click)="goAccreditation()">
                        <div class="header">{{'__HOME_MULTI_PERSONAL_INSIGHTS__' | translate}}</div>
                        <div class="body">
                            <app-inline-svg [file]="'assets/img/journey/personal-insights.svg'" alt=""></app-inline-svg>
                            <div>{{ "__HOME_MULTI_PERSONAL_INSIGHTS_TEXT__" | translate }}</div>
                        </div>
                    </div>
                </div>

                <div class="side-wrapper-right">
                    <!-- Discussion Bar and Leaderboard -->
                    <div class="side-container buttons-wrap"
                         *ngIf="userInfo.client_id == 197">
                        <div *ngIf="socialEnabled" (click)="goToSocial()" class="header-button-wrap">
                            <span class="header-btn-text">{{ "__HOME_MULTI_DISCUSSION_BAR__" | translate }}</span>
                            <button class="icon discussion-bar"></button>
                        </div>
                        <div *ngIf="leaderboardEnabled" (click)="goToLeaderboard()" class="header-button-wrap margin-left">
                            <span class="header-btn-text">{{ "__HOME_MULTI_GLOBAL_LEADERBOARD__" | translate }}</span>
                            <button class="icon leaderboard"></button>
                        </div>
                    </div>

                    <!-- Accreditation -->
                    <div class="side-container accreditation"
                         *ngIf="userInfo.client_id == 167 && !!accreditationTemplate && userService.userInfo.is_coaching"
                         (click)="goAccreditation()">
                        <div class="header">{{'Accreditation' | translate}}</div>
                        <div class="body">
                            <img src="assets/img/inspire/accreditation.svg" alt="">
                            <div>{{ "__HOME_MULTI_CLICK_TO_BEGIN_YOUR_CERTIFICATION_PROCESS__" | translate }}</div>
                        </div>
                    </div>

                  <div class="side-container upcoming-activity"
                         *ngIf="userInfo.client_id == 70 && upcomingEventsList && upcomingEventsList.length > 0">
                    <div class="header lighter clickable" (click)="goTasks()">
                      <div>{{'__HOME_INSPIRE_UPCOMING_ACTIVITIES__' | translate}}:</div>
                      <div *ngIf="upcomingEventsList.length" class="number"><span>{{upcomingEventsList.length}}</span></div>
                    </div>
                    <div class="body no-gap" style="padding: .5rem;">
                      <div *ngFor="let item of paginatedUpcomingEvents; let i = index" class="link"
                           (click)="goToTask(item)"
                           [ngClass]="{'long-list': upcomingEventsList.length >= 10}">
                        <div class="upcoming-activity-position">{{(upcomingEventsPage - 1) * upcomingEventsPageSize + i + 1}}.</div>
                        <div class="upcoming-activity-content">
                          <div class="upcoming-activity-title" [innerHTML]="item.title | safeHtml"></div>
                          <div class="upcoming-activity-deadline">{{'__HOME_INSPIRE_UPCOMING_ACTIVITIES_DEADLINE__' | translate}}: {{item.deadline_at.output.iso | amDateFormat : 'D MMMM' }}</div>
                        </div>
                        <div class="upcoming-activity-status">
                          <img *ngIf="!item.status" [src]="'assets/img/journey/status-disabled.svg'"/>
                          <img *ngIf="item.status" [src]="'assets/img/journey/status-enabled.svg'"/>
                        </div>
                      </div>
                      <!-- Pagination controls -->
                      <div class="pagination-controls" *ngIf="upcomingEventsTotalPages > 1">
                        <button class="arrow-circle" (click)="prevUpcomingEventsPage()" [disabled]="upcomingEventsPage === 1">
                          &#8592;
                        </button>
                        <span class="page-indicator">{{'__HOME_INSPIRE_UPCOMING_ACTIVITIES_PAGE__' | translate}} {{upcomingEventsPage}} / {{upcomingEventsTotalPages}}</span>
                        <button class="arrow-circle" (click)="nextUpcomingEventsPage()" [disabled]="upcomingEventsPage === upcomingEventsTotalPages">
                          &#8594;
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            <ion-footer *ngIf="menuVisible" slot="fixed" [@enterUp]>
                <app-footer [forAdmin]="(authService.getUserType() === 'manager')" [level]="'learner'"
                            [progress]="progress" currentPage="home"></app-footer>
            </ion-footer>
        </div>

        <app-footer-logo [veeam]="true"></app-footer-logo>
          </div>
</ion-content>
